export default {"src":"/_next/static/media/linkedin-icon.cbf7bdc6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};